import { ChangeEvent, Component } from "react"
import { Col, Form, Button, Image } from "react-bootstrap"
import ClinicSearchOptions from "../../api/Clinics/Models/ClinicSearchOptions"
import CollectionSite from "../../api/Location/LocationModel/CollectionSite"
import clearFiltersIcon from "../../assets/images/clear-filters.png"
import ClinicSearchPrice from "../../api/Clinics/Models/ClinicSearchPrice"

type FilterFunction = (site: CollectionSite) => boolean

export interface FilterProps {
  sites: CollectionSite[]
  radius: number
  clinicSearchOptions?: ClinicSearchOptions
  priceTiers?: ClinicSearchPrice[]
  filter?: FilterFunction
  onRadiusChanged: (radius: number) => void
  onFilterChanged: (filter?: FilterFunction) => void
}

const DEFAULT_MIN_RADIUS = 15
const DEFAULT_MAX_RADIUS = 50

export default class Filter extends Component<FilterProps> {

  handleRadiusChange = (e: ChangeEvent<HTMLInputElement>) => this.props.onRadiusChanged(parseInt(e.target.value) as number)

  getFilters() {
    if (this.props.sites.length === 0 ) return []
    const result = [
      { name: "Primary", filter: (site: CollectionSite) => site.GroupName === "Primary" || site.GroupName === "Favorite" },
    ]
    const sites = this.props.sites.map(item => {
      const newSite = {...item}
      newSite.PriceTier = item.IsMarketPlace ? item.PriceTier : ""
      return newSite
    })

    if (this.props.priceTiers) {
      this.props.priceTiers.forEach(pt => {
        const existsTier = sites.some(item => item.PriceTier === pt.Name)
        if (existsTier) {
          result.push({
            name: pt.DisplayName || pt.Name,
            filter: (site: CollectionSite) => site.PriceTier?.toLowerCase() === pt.Name.toLowerCase()
          })
        }
      })
    }

    result.push({ name: "Non MarketPlace", filter: (site: CollectionSite) => site.GroupName === "NonMarketplace" && !site.Private })

    return result
  }
  
  render() {
    const minRadius = this.props.clinicSearchOptions?.SearchRadius1 || DEFAULT_MIN_RADIUS
    const maxRadius = this.props.clinicSearchOptions?.SearchRadius2 || DEFAULT_MAX_RADIUS

    const filters = this.getFilters()
    return (
      <Form className="site-search-filter">
        <Form.Row>
          <Col>
            <Form.Label className="secondary font-weight-bold">Radius</Form.Label>
            <Form.Check type="radio" name="radius" id="radius-min" className="abc-radio" value={minRadius} label={`Min Radius (${minRadius} Miles)`} checked={this.props.radius === minRadius} onChange={(e: ChangeEvent<HTMLInputElement>) => this.props.onRadiusChanged(parseInt(e.target.value) as number)} />
            <Form.Check type="radio" name="radius" id="radius-max" className="abc-radio" value={maxRadius} label={`Max Radius (${maxRadius} Miles)`} checked={this.props.radius === maxRadius} onChange={(e: ChangeEvent<HTMLInputElement>) => this.props.onRadiusChanged(parseInt(e.target.value) as number)} />
          </Col>
        </Form.Row>
        {filters.length > 0 && <Form.Row>
          <Col xs={10} className="secondary py-2 font-weight-bold">Filter</Col>
          <Col xs={2} className="text-center">
            <Button variant="icon-link" className="p-0" onClick={() => this.props.onFilterChanged(undefined)}>
              <Image src={clearFiltersIcon} title="Clear Filter" width={17} height={17} />
            </Button>
          </Col>
        </Form.Row>}
        {filters.map(filter => {
          return (
            <Form.Row key={filter.name} className={this.props.filter && this.props.filter === filter.filter ? "selected" : ""}>
              <Col xs={10} className="d-flex align-items-center">
                <Button variant="underline-link" className="text-left p-0 w-100" onClick={() => this.props.onFilterChanged(filter.filter)}>{filter.name}</Button>
              </Col>
              <Col xs={2} className="d-flex align-items-center justify-content-center">
                  {this.props.sites.filter(site => filter.filter(site)).length.toString()}
              </Col>
            </Form.Row>)
        })}
      </Form>
    )
  }
}
